import { fg } from '@confluence/feature-gating';

import { useIsActionDisabledForWorkspace } from './useIsActionDisabledForWorkspace.ts';

export const useShouldShowDSPWarningForWorkspaceRole = (rolePermissions: string[]): boolean => {
	const hasPublicLinksPermission = rolePermissions.includes('MANAGE_PUBLIC_LINKS');
	const hasAnonymousAccessPermission = rolePermissions.includes('NONLICENSED_USER_MANAGEMENT');

	const isPublicLinksActionDisabled = useIsActionDisabledForWorkspace({
		action: 'PUBLIC_LINKS',
		skip: !fg('confluence_show_dsp_warning') || !hasPublicLinksPermission,
	});
	const isAnonymousAccessActionDisabled = useIsActionDisabledForWorkspace({
		action: 'ANONYMOUS_ACCESS',
		skip: !fg('confluence_show_dsp_warning') || !hasAnonymousAccessPermission,
	});

	return (
		fg('confluence_show_dsp_warning') &&
		((isPublicLinksActionDisabled && hasPublicLinksPermission) ||
			(isAnonymousAccessActionDisabled && hasAnonymousAccessPermission))
	);
};
